import { render, staticRenderFns } from "./PedidoList.vue?vue&type=template&id=6660eb46"
import script from "./PedidoList.vue?vue&type=script&lang=js"
export * from "./PedidoList.vue?vue&type=script&lang=js"
import style0 from "./PedidoList.vue?vue&type=style&index=0&id=6660eb46&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports